/* eslint-disable */

export interface CustomerTokenListItemDto {
  id: number;
  key: string;
  type: string;
  subjectId: string;
  sessionId: string;
  clientId: string;
  description: string | null;
  creationTime: Date;
  expiration: Date | null;
  customerName: string | null;
  customerId: string | null;
  userId: string | null;
  mandantId: string | null;
  mandantName: string | null;
}

export const fixCustomerTokenListItemDtoFromJson = (dto?: CustomerTokenListItemDto | null): void => {
  if (!dto) {
    return;
  }
  dto.creationTime = dto.creationTime && new Date(dto.creationTime);
  dto.expiration = dto.expiration && new Date(dto.expiration);
};

export const fixCustomerTokenListItemDtoToJson = (dto?: CustomerTokenListItemDto | null): void => {
  if (!dto) {
    return;
  }
};
